import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import PCHome from '@/views/pc/home.vue'
import MHome from '@/views/m/home.vue'
import { Message } from 'element-ui'

import { IsPC as IsPC } from '@/utils/util'

Vue.use(VueRouter)

// if(window.location.host == 'zzcl.kjcxchina.com'){
//   indexUrl = '../views/pc/index.vue'
// }
// if(window.location.host=='jt.zzcl.kjcxchina.com'){
//   indexUrl = '../views/pc/group_index.vue'
//   // @/views/pc/group_index.vue
// }

const routes_pc = [
  // {
  //   path: '*',
  //   redirect: '/'
  // },
  {
    path: '/forgotPsd',
    name: 'ForgotPsd',
    component: () => import('@/views/pc/forgotPsd.vue')
  },
  {
    path: '/',
    name: 'PCHome',
    component: PCHome,
    children: [
      //首页
      {
        path: '/',
        name: 'Index',
        component: () => import('@/views/pc/index.vue'),
        meta:{
          topState:true,
          rightIsShow:true,
        }
        
      },{
        // 数据看板
        path: '/dataIndex',
        name: 'dataIndex',
        component: () => import('@/views/pc/dataIndex/index.vue'),
        meta: {
          headerIsShow: true,
          footerIsShow: true,
        }
        
      },{
        path: '/course/index',
        name: 'course/index',
        component: () => import('@/views/pc/course/index.vue'),
        meta: {
          headerIsShow: true,
          footerIsShow: true,
          rightIsShow:true,
        }
      },{
        path: '/course/list',
        name: 'course/list',
        component: () => import('@/views/pc/course/list.vue'),
        meta: {
          rightIsShow:true,
        }
      },{
        path: '/course/detail',
        name: 'course/detail',
        component: () => import('@/views/pc/course/detail.vue'),
      },{
        path: '/course/liveIndex',
        name: 'course/liveIndex',
        component: () => import('@/views/pc/course/liveIndex.vue'),
      },{
        path: '/course/videoPlay',
        name: 'course/videoPlay',
        component: () => import('@/views/pc/course/videoPlay.vue'),
      },{
        path: '/course/liveDetail',
        name: 'course/liveDetail',
        component: () => import('@/views/pc/course/liveDetail.vue'),
      },{
        path: '/course/dggj',
        name: 'course/dggj',
        component: () => import('@/views/pc/course/dggj.vue'),
      },{
        path: '/course/nzgzq',
        name: 'course/nzgzq',
        component: () => import('@/views/pc/course/nzgzq.vue'),
      },{
        path: '/course/jpk',
        name: 'course/jpk',
        component: () => import('@/views/pc/course/jpk.vue'),
      },{
        path: '/offline_course/list',
        name: 'offline_course/list',
        component: () => import('@/views/pc/offline_course/list.vue'),
      },{
        path: '/offline_course/detail',
        name: 'offline_course/detail',
        component: () => import('@/views/pc/offline_course/detail.vue'),
      },{
        path: '/subject/list',
        name: 'subject/list',
        component: () => import('@/views/pc/subject/list.vue'),
      },{
        path: '/subject/detail',
        name: 'subject/detail',
        component: () => import('@/views/pc/subject/detail.vue'),
      },{
        path: '/college/list',
        name: 'college/list',
        component: () => import('@/views/pc/college/list.vue'),
      },{
        path: '/college/detail',
        name: 'college/detail',
        component: () => import('@/views/pc/college/detail.vue'),
      },{
        path: '/train/list',
        name: 'train/list',
        component: () => import('@/views/pc/train/list.vue'),
      },{
        path: '/openClass/list',
        name: 'openClass',
        component: () => import('@/views/pc/openClass/list.vue'),
      },{
        path: '/openClass/detail',
        name: 'openClass/detail',
        component: () => import('@/views/pc/openClass/detail.vue'),
      },{
        path: '/openClass/detailTrain',
        name: 'openClass/detailTrain',
        component: () => import('@/views/pc/openClass/detailTrain.vue'),
      },{
        path: '/news_list',
        name: 'news/news_list',
        component: () => import('@/views/pc/news/news_list.vue'),
        meta:{
          rightIsShow:true,
        }
      },{
        path: '/news_detail',
        name: 'news/news_detail',
        component: () => import('@/views/pc/news/news_detail.vue'),
      },{
        path: '/gjrc/index',
        name: 'gjrc/index',
        component: () => import('@/views/pc/gjrc/index.vue'),
      },{
        path: '/gjrc/list',
        name: 'gjrc/list',
        component: () => import('@/views/pc/gjrc/list.vue'),
        meta:{
          rightIsShow:true,
        }
      },{
        path: '/gjrc/detail',
        name: 'gjrc/detail',
        component: () => import('@/views/pc/gjrc/detail.vue'),
      },{
        path: '/handler/list',
        name: 'handler/list',
        component: () => import('@/views/pc/handler/list.vue'),
      },{
        path: '/handler/detail',
        name: 'handler/detail',
        component: () => import('@/views/pc/handler/detail.vue'),
      },{
        path: '/studio/list',
        name: 'studio/list',
        component: () => import('@/views/pc/studio/list.vue'),
        meta:{
          rightIsShow:true,
        }
      },{
        path: '/studio/index',
        name: 'studio/index',
        component: () => import('@/views/pc/studio/index.vue'),
      },{
        path: '/studio/detail',
        name: 'studio/detail',
        component: () => import('@/views/pc/studio/detail.vue'),
      },{
        path: '/skills/index',
        name: 'skills/index',
        component: () => import('@/views/pc/skills/index.vue'),
        meta:{
          rightIsShow:true,
        }
      },{
        path: '/skills/list',
        name: 'skills/list',
        component: () => import('@/views/pc/skills/list.vue'),
        
      },{
        path: '/skills/detail',
        name: 'skills/detail',
        component: () => import('@/views/pc/skills/detail.vue'),
      },{
        path: '/project/list',
        name: 'project/list',
        component: () => import('@/views/pc/project/list.vue'),
      },{
        path: '/project/index',
        name: 'project/index',
        component: () => import('@/views/pc/project/index.vue'),
      },{
        path: '/project/detail',
        name: 'project/detail',
        component: () => import('@/views/pc/project/detail.vue'),
      },{
        path: '/problem/list',
        name: 'problem/list',
        component: () => import('@/views/pc/problem/list.vue'),
      },{
        path: '/problem/index',
        name: 'problem/index',
        component: () => import('@/views/pc/problem/index.vue'),
      },{
        path: '/problem/detail',
        name: 'problem/detail',
        component: () => import('@/views/pc/problem/detail.vue'),
      },{
        path: '/achievement/index',
        name: 'achievement/index',
        component: () => import('@/views/pc/achievement/index.vue'),
        meta:{
          topState:true
        }
      },{
        path: '/achievement/list',
        name: 'achievement/list',
        component: () => import('@/views/pc/achievement/list.vue'),
        
      },{
        path: '/achievement/detail',
        name: 'achievement/detail',
        component: () => import('@/views/pc/achievement/detail.vue'),
      },{
        path: '/achievement/achieveList',
        name: 'achievement/achieveList',
        component: () => import('@/views/pc/achievement/achieveList.vue'),
        meta:{
          rightIsShow:true,
        }
      },{
        path: '/achievement/achieveDetail',
        name: 'achievement/achieveDetail',
        component: () => import('@/views/pc/achievement/achieveDetail.vue'),
      },{
        path: '/userData/index',
        name: 'userData/index',
        component: () => import('@/views/pc/userData/index.vue'),
        redirect:'/userData/myClass',
        children:[
          {
            path: '/userData/myClass',
            name: 'userData/myClass',
            component: () => import('@/views/pc/userData/myClass.vue'),
          },
          {
            path: '/userData/myTrain',
            name: 'userData/myTrain',
            component: () => import('@/views/pc/userData/myTrain.vue'),
          },
          {
            path: '/userData/account',
            name: 'userData/account',
            component: () => import('@/views/pc/userData/account.vue'),
          },{
            path: '/userData/companyInfo',
            name: 'userData/companyInfo',
            component: () => import('@/views/pc/userData/companyInfo.vue'),
          },{
            path: '/userData/myBook',
            name: 'userData/myBook',
            component: () => import('@/views/pc/userData/myBook.vue'),
          },{
            path: '/userData/myExam',
            name: 'userData/myExam',
            component: () => import('@/views/pc/userData/myExam.vue'),
          },{
            path: '/userData/myCourse',
            name: 'userData/myCourse',
            component: () => import('@/views/pc/userData/myCourse.vue'),
          },{
            path: '/userData/userInfo',
            name: 'userData/userInfo',
            component: () => import('@/views/pc/userData/userInfo.vue'),
          },
        ]
      },{
        path: '/exam/index',
        name: 'exam/index',
        component: () => import('@/views/pc/exam/index.vue'),
        meta: {
          headerIsShow: true,
        }
      },{
        path: '/exam/indexTrain',
        name: 'exam/indexTrain',
        component: () => import('@/views/pc/exam/indexTrain.vue'),
        meta: {
          headerIsShow: true,
        }
      },{
        path: '/exam/list',
        name: 'exam/list',
        component: () => import('@/views/pc/exam/list.vue'),
      },{
        path: '/exam/listTrain',
        name: 'exam/listTrain',
        component: () => import('@/views/pc/exam/listTrain.vue'),
      },{
        path: '/search',
        name: 'search',
        component: () => import('@/views/pc/search.vue'),
      }
    
     
    ]
  }
]
const routes_m = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'mHome',
    component: MHome,
    children: [
      //首页
      {
        path: '/',
        name: 'Index',
        component: () => import('@/views/m/index.vue'),
        meta:{
        }
        
      },{
        path: '/course/index',
        name: 'course/index',
        component: () => import('@/views/m/course/index.vue'),
        meta: {
          headerIsShow: true,
          footerIsShow: true,
        }
      },{
        path: '/course/list',
        name: 'course/list',
        component: () => import('@/views/m/course/list.vue'),
        meta:{
          title:'选课中心'
        }
      },{
        path: '/course/detail',
        name: 'course/detail',
        component: () => import('@/views/m/course/detail.vue'),
        meta:{
          title:'课程详情'
        }
      },{
        path: '/course/liveIndex',
        name: 'course/liveIndex',
        component: () => import('@/views/m/course/liveIndex.vue'),
      },{
        path: '/course/videoPlay',
        name: 'course/videoPlay',
        component: () => import('@/views/m/course/videoPlay.vue'),
      },{
        path: '/course/liveDetail/:no/:id',
        name: 'course/liveDetail',
        component: () => import('@/views/m/course/liveDetail.vue'),
        meta:{
          footerIsShow:true
        }
      },{
        path: '/course/liveDetailDemo/:no/:id',
        name: 'course/liveDetailDemo',
        component: () => import('@/views/m/course/liveDetailDemo.vue'),
        meta:{
          footerIsShow:true
        }
      },{
        path: '/offline_course/list',
        name: 'offline_course/list',
        component: () => import('@/views/m/offline_course/list.vue'),
        meta:{
          title:'课程列表'
        }
      },{
        path: '/offline_course/detail',
        name: 'offline_course/detail',
        component: () => import('@/views/m/offline_course/detail.vue'),
        meta:{
          title:'课程详情'
        }
      },{
        path: '/course/dggj',
        name: 'course/dggj',
        component: () => import('@/views/m/course/dggj.vue'),
        meta:{
          title:'大国工匠'
        }
      },{
        path: '/course/nzgzq',
        name: 'course/nzgzq',
        component: () => import('@/views/m/course/nzgzq.vue'),
        meta:{
          title:'女职工专区'
        }
      },{
        path: '/course/jpk',
        name: 'course/jpk',
        component: () => import('@/views/m/course/jpk.vue'),
        meta:{
          title:'精品课'
        }
      },{
        path: '/subject/list',
        name: 'subject/list',
        component: () => import('@/views/m/subject/list.vue'),
        meta:{
          title:'专题列表'
        }
      },{
        path: '/subject/detail',
        name: 'subject/detail',
        component: () => import('@/views/m/subject/detail.vue'),
        meta:{
          title:'专题详情'
        }
      },{
        path: '/college/list',
        name: 'college/list',
        component: () => import('@/views/m/college/list.vue'),
        meta:{
          title:'工匠学院分院列表'
        }
      },{
        path: '/college/detail',
        name: 'college/detail',
        component: () => import('@/views/m/college/detail.vue'),
        meta:{
          title:'工匠学院分院详情'
        }
      },{
        path: '/train/list',
        name: 'train/list',
        component: () => import('@/views/m/train/list.vue'),
        meta:{
          title:'技能培训班列表'
        }
      },{
        path: '/openClass/list',
        name: 'openClass',
        component: () => import('@/views/m/openClass/list.vue'),
        meta:{
          title:'公开班级'
        }
      },{
        path: '/openClass/detail',
        name: 'openClass/detail',
        component: () => import('@/views/m/openClass/detail.vue'),
        meta:{
          title:'课程详情'
        }
      },{
        path: '/openClass/detailTrain',
        name: 'openClass/detailTrain',
        component: () => import('@/views/m/openClass/detailTrain.vue'),
        meta:{
          title:'课程详情'
        }
      },{
        path: '/news_list',
        name: 'news/news_list',
        component: () => import('@/views/m/news/news_list.vue'),
        meta:{
          title:'新闻列表'
        }
      },{
        path: '/news_detail',
        name: 'news/news_detail',
        component: () => import('@/views/m/news/news_detail.vue'),
        meta:{
          title:'新闻详情'
        }
      },{
        path: '/gjrc/index',
        name: 'gjrc/index',
        component: () => import('@/views/m/gjrc/index.vue'),
      },{
        path: '/gjrc/list',
        name: 'gjrc/list',
        component: () => import('@/views/m/gjrc/list.vue'),
        meta:{
          title:'工匠人才',
        }
      },{
        path: '/gjrc/detail',
        name: 'gjrc/detail',
        component: () => import('@/views/m/gjrc/detail.vue'),
        meta:{
          title:'详情'
        }
      },{
        path: '/handler/list',
        name: 'handler/list',
        component: () => import('@/views/m/handler/list.vue'),
        meta:{
          title:'优秀选手'
        }
      },{
        path: '/handler/detail',
        name: 'handler/detail',
        component: () => import('@/views/m/handler/detail.vue'),
        meta:{
          title:'详情'
        }
      },{
        path: '/studio/list',
        name: 'studio/list',
        component: () => import('@/views/m/studio/list.vue'),
        meta:{
          title:'创新工作室'
        }
      },{
        path: '/studio/index',
        name: 'studio/index',
        component: () => import('@/views/m/studio/index.vue'),
      },{
        path: '/studio/detail',
        name: 'studio/detail',
        component: () => import('@/views/m/studio/detail.vue'),
        meta:{
          title:'详情'
        }
      },{
        path: '/skills/index',
        name: 'skills/index',
        component: () => import('@/views/m/skills/index.vue'),
      },{
        path: '/skills/list',
        name: 'skills/list',
        component: () => import('@/views/m/skills/list.vue'),
        meta:{
          title:'技能竞赛'
        }
      },{
        path: '/skills/detail',
        name: 'skills/detail',
        component: () => import('@/views/m/skills/detail.vue'),
        meta:{
          title:'详情'
        }
      },{
        path: '/project/list',
        name: 'project/list',
        component: () => import('@/views/m/project/list.vue'),
        meta:{
          title:'创新项目'
        }
      },{
        path: '/project/index',
        name: 'project/index',
        component: () => import('@/views/m/project/index.vue'),
      },{
        path: '/project/detail',
        name: 'project/detail',
        component: () => import('@/views/m/project/detail.vue'),
        meta:{
          title:'详情'
        }
      },{
        path: '/project/form',
        name: 'project/form',
        component: () => import('@/views/m/project/form.vue'),
        meta:{
          title:'征集信息'
        }
      },{
        path: '/problem/list',
        name: 'problem/list',
        component: () => import('@/views/m/problem/list.vue'),
        meta:{
          title:'疑难攻关'
        }
      },{
        path: '/problem/index',
        name: 'problem/index',
        component: () => import('@/views/m/problem/index.vue'),
      },{
        path: '/problem/detail',
        name: 'problem/detail',
        component: () => import('@/views/m/problem/detail.vue'),
        meta:{
          title:'详情'
        }
      },{
        path: '/problem/form',
        name: 'problem/form',
        component: () => import('@/views/m/problem/form.vue'),
        meta:{
          footerIsShow:true,
          title:'征集信息'
        }
      },{
        path: '/achievement/index',
        name: 'achievement/index',
        component: () => import('@/views/m/achievement/index.vue'),
      },{
        path: '/achievement/list',
        name: 'achievement/list',
        component: () => import('@/views/m/achievement/list.vue'),
        meta:{
          title:'创新成果'
        }
      },{
        path: '/achievement/detail',
        name: 'achievement/detail',
        component: () => import('@/views/m/achievement/detail.vue'),
        meta:{
          title:'详情'
        }
      },{
        path: '/achievement/achieveList',
        name: 'achievement/achieveList',
        component: () => import('@/views/m/achievement/achieveList.vue'),
        meta:{
          title:'创新成果'
        }
      },{
        path: '/achievement/achieveDetail',
        name: 'achievement/achieveDetail',
        component: () => import('@/views/m/achievement/achieveDetail.vue'),
        meta:{
          title:'详情'
        }
      },{
        path: '/userData/index',
        name: 'userData/index',
        component: () => import('@/views/m/userData/index.vue'),
      },{
        path: '/userData/myClass',
        name: 'userData/myClass',
        component: () => import('@/views/m/userData/myClass.vue'),
        meta:{
          title:'我的班级'
        }
      },
      {
        path: '/userData/myTrain',
        name: 'userData/myTrain',
        component: () => import('@/views/m/userData/myTrain.vue'),
        meta:{
          title:'技能培训班'
        }
      },
      {
        path: '/userData/account',
        name: 'userData/account',
        component: () => import('@/views/m/userData/account.vue'),
        meta: {
          headerIsShow: true,
          footerIsShow: true,
          title:'我的账户'
        }
      },{
        path: '/userData/companyInfo',
        name: 'userData/companyInfo',
        component: () => import('@/views/m/userData/companyInfo.vue'),
      },{
        path: '/userData/myBook',
        name: 'userData/myBook',
        component: () => import('@/views/m/userData/myBook.vue'),
      },{
        path: '/userData/myExam',
        name: 'userData/myExam',
        component: () => import('@/views/m/userData/myExam.vue'),
      },{
        path: '/userData/myCourse',
        name: 'userData/myCourse',
        component: () => import('@/views/m/userData/myCourse.vue'),
        meta:{
          title:'我的课程'
        }
      },{
        path: '/userData/userInfo',
        name: 'userData/userInfo',
        component: () => import('@/views/m/userData/userInfo.vue'),
        meta: {
          headerIsShow: true,
          footerIsShow: true,
          title:'个人资料'
        }
      },{
        path: '/userData/form',
        name: 'userData/form',
        component: () => import('@/views/m/userData/form.vue'),
        meta: {
          headerIsShow: true,
          footerIsShow: true,
          title:'修改信息'
        }
      },{
        path: '/exam/index',
        name: 'exam/index',
        component: () => import('@/views/m/exam/index.vue'),
        meta: {
          headerIsShow: true,
          meta:{
            title:'考试'
          }
        }
      },{
        path: '/exam/indexTrain',
        name: 'exam/indexTrain',
        component: () => import('@/views/m/exam/indexTrain.vue'),
        meta: {
          headerIsShow: true,
          meta:{
            title:'考试'
          }
        }
      },{
        path: '/login',
        name: 'login',
        component: () => import('@/views/m/login.vue'),
        meta: {
          footerIsShow: true,
        }
      },{
        path: '/exam/index',
        name: 'exam/index',
        component: () => import('@/views/m/exam/index.vue'),
        meta: {
          headerIsShow: true,
        }
      },{
        path: '/exam/list',
        name: 'exam/list',
        component: () => import('@/views/m/exam/list.vue'),
      },{
        path: '/exam/listTrain',
        name: 'exam/listTrain',
        component: () => import('@/views/m/exam/listTrain.vue'),
      },{
        path: '/exam/score',
        name: 'exam/score',
        component: () => import('@/views/m/exam/score.vue'),
        meta:{
          title:'考试成绩'
        }
      },{
        path: '/exam/scoreTrain',
        name: 'exam/scoreTrain',
        component: () => import('@/views/m/exam/scoreTrain.vue'),
        meta:{
          title:'考试成绩'
        }
      },{
        path: '/search',
        name: 'search',
        component: () => import('@/views/m/search.vue'),
        meta:{
          title:'搜索'
        }
      }
      // {
      //   path: '/exam/list',
      //   name: 'exam/list',
      //   component: () => import('@/views/pc/exam/list.vue'),
      // }
    
     
    ]
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: IsPC() ? routes_pc : routes_m
})

router.beforeEach(async(to, from, next) => {
  const userData = localStorage.getItem('is_auth_idcard')
  const ispc = IsPC();
  console.log(to.path,to.path !== '/userData/account',ispc)
  if (userData && userData == 0) {
    if (ispc) {
      if (to.path !== '/userData/account') {
        Message.error('请先去实名认证')
        next('/userData/account');
      } else {
        next();
      }
    }else {
      if (to.path !== '/userData/form') {
        Message.error('请先去实名认证')
        next('/userData/form?num=1');
      } else {
        next();
      }
    }
    
  }else {
    next()
  }
})

export default router
